var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-xs":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":"","justify-center":""}},[_c('v-flex',{attrs:{"text-xs-center":"","xs12":""}},[_c('img',{attrs:{"id":"intro","src":_vm.GMLogo}})])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }